module.exports = __webpack_public_path__ + "img/BannerNewMobile.e38f93aa.png";